/* Draft-only Zen for Men W3 recovery.
   W3 Custom Product Options' documented script initializer is tried only
   when the widget remains empty after the Shopify app embed has had time
   to initialize it. This does not create options or alter pricing/cart data. */
(() => {
  'use strict';
  if (window.__ycZenW3RecoveryInstalled) return;
  window.__ycZenW3RecoveryInstalled = true;

  const root = document.querySelector('.w3-product-options[data-product-id="10820767547532"]');
  if (!root || !root.closest('form')) return;
  const optionFieldsPresent = () => Boolean(root.querySelector(
    '.product-options-control-container, .product-options-checkbox, .product-options-radiobutton, [data-field-id]'
  ));

  const loadScript = url => new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.onload = resolve;
    script.onerror = () => reject(new Error('Could not load ' + url));
    document.head.appendChild(script);
  });

  async function getJQuery() {
    if (typeof window.jQuery === 'function' && window.jQuery.fn) return window.jQuery;
    // Load a current isolated jQuery instance rather than W3's documented old
    // 1.9.1 version. noConflict restores the theme's previous $ and jQuery.
    await loadScript('https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js');
    if (typeof window.jQuery !== 'function') throw new Error('jQuery unavailable for W3');
    return window.jQuery.noConflict(true);
  }

  async function loadW3() {
    if (typeof window.w3productOptionsJS === 'function') return;
    // Vendor's documented W3 storefront loader.
    if (Array.from(document.scripts).some(s => s.src.includes('productoptions.w3apps.co/js/options.js'))) {
      // Avoid injecting the same vendor script a second time if its embed is late.
      for (let i = 0; i < 12 && typeof window.w3productOptionsJS !== 'function'; i++) {
        await new Promise(resolve => setTimeout(resolve, 250));
      }
    } else {
      await loadScript('https://productoptions.w3apps.co/js/options.js');
    }
    if (typeof window.w3productOptionsJS !== 'function') throw new Error('W3 initializer unavailable');
  }

  let attempting = false;
  async function recover() {
    if (optionFieldsPresent() || attempting) return;
    attempting = true;
    try {
      const jq = await getJQuery();
      if (optionFieldsPresent()) return;
      await loadW3();
      if (optionFieldsPresent()) return;
      window.w3productOptionsJS(jq);
    } catch (error) {
      console.warn('[Yellow Creek] W3 Zen for Men recovery:', error);
    }
  }

  // Allow the app's normal embed first. Fall back only if the widget is blank.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(recover, 2500), { once: true });
  } else {
    setTimeout(recover, 2500);
  }
})();
